<footer>
  <h2 [innerHTML]="strings.footerTitle"></h2>
  <div class="footer-navigation">
    <div class="footer-links-left">
      <a href="#about" class="footer-link">{{strings.about}}</a>
      <a href="#work" class="footer-link">{{strings.portfolio}}</a>
      <a href="#skills" class="footer-link">{{strings.skills}}</a>
      <button class="footer-link" (click)="setTranslation('en')">&lt; En &gt;</button>
    </div>
    <div class="footer-center">
      <app-empty-tag-v2></app-empty-tag-v2>
    </div>
    <div class="footer-links-right">
      <button class="footer-link" (click)="setTranslation('ba')">&lt; Ba &gt;</button>
      <a href="#experience" class="footer-link">{{strings.experience}}</a>
      <a href="#education" class="footer-link">{{strings.education}}</a>
      <a href="#certificates" class="footer-link">{{strings.certificates}}</a>
    </div>
  </div>
  <h1>AMIR.KASUMOVIC@LIVE.COM</h1>
  <div class="social-icons">
    <a href="https://github.com/Cores13" target="_blank" rel="noopener">
      <img src="assets/github.webp" alt="Amir Kasumovic github profile" loading="lazy">
    </a>
    <a href="https://ba.linkedin.com/in/amir-kasumovic-b02507163" target="_blank" rel="noopener">
      <img src="assets/linkedin.webp" alt="Amir Kasumovic LinkedIn profile" loading="lazy">
    </a>
  </div>
</footer>
